import React, { useState, useEffect } from 'react';
import { database } from '../firebase';
import { ref, onValue, set, remove } from 'firebase/database';
import '../styles/global.css';

const WildcardManagement = () => {
    const [wildcards, setWildcards] = useState({});
    const [loading, setLoading] = useState(true);
    const [newEmail, setNewEmail] = useState('');
    const [newReason, setNewReason] = useState('');

    useEffect(() => {
        const wildcardRef = ref(database, 'wildcard_users');
        const unsub = onValue(wildcardRef, (snapshot) => {
            if (snapshot.exists()) {
                setWildcards(snapshot.val());
            } else {
                setWildcards({});
            }
            setLoading(false);
        });
        return () => unsub();
    }, []);

    const handleAddWildcard = async () => {
        if (!newEmail || !newReason) return alert('Por favor ingresa email y motivo');
        const uid = crypto.randomUUID();
        try {
            await set(ref(database, `wildcard_users/${uid}`), {
                uid,
                email: newEmail,
                reason: newReason,
                timestamp: Date.now()
            });
            setNewEmail('');
            setNewReason('');
            alert('Usuario comodín añadido');
        } catch (e) {
            alert('Error: ' + e.message);
        }
    };

    const handleRemoveWildcard = async (uid) => {
        if (!window.confirm('¿Eliminar este usuario comodín?')) return;
        try {
            await remove(ref(database, `wildcard_users/${uid}`));
            alert('Usuario eliminado');
        } catch (e) {
            alert('Error: ' + e.message);
        }
    };

    if (loading) return <div className="loading">Cargando usuarios comodín...</div>;

    return (
        <div className="wildcard-management" style={{ padding: '20px' }}>
            <h1 style={{ color: 'var(--accent)' }}>Gestión de Usuarios Comodín (Wildcards)</h1>
            <p style={{ opacity: 0.7, marginBottom: '20px' }}>Los usuarios en esta lista tienen permisos especiales o saltan validaciones de licencia.</p>

            <div className="card" style={{ marginBottom: '30px', background: 'var(--bg-secondary)', padding: '20px', borderRadius: '12px' }}>
                <h2>Añadir Nuevo Comodín</h2>
                <div style={{ display: 'grid', gap: '10px', marginTop: '15px' }}>
                    <input
                        type="email"
                        placeholder="Email del usuario"
                        value={newEmail}
                        onChange={(e) => setNewEmail(e.target.value)}
                        style={{ padding: '10px', background: 'var(--bg-primary)', color: 'white', border: '1px solid #444', borderRadius: '4px' }}
                    />
                    <input
                        type="text"
                        placeholder="Motivo / Descripción"
                        value={newReason}
                        onChange={(e) => setNewReason(e.target.value)}
                        style={{ padding: '10px', background: 'var(--bg-primary)', color: 'white', border: '1px solid #444', borderRadius: '4px' }}
                    />
                    <button
                        onClick={handleAddWildcard}
                        style={{ padding: '12px', background: 'var(--accent)', color: 'white', border: 'none', borderRadius: '50px', fontWeight: 'bold', cursor: 'pointer' }}
                    >
                        + Añadir a la Lista
                    </button>
                </div>
            </div>

            <div className="card" style={{ background: 'var(--bg-secondary)', padding: '20px', borderRadius: '12px' }}>
                <h2>Lista de Usuarios Activos</h2>
                <div style={{ marginTop: '15px' }}>
                    {Object.keys(wildcards).length === 0 ? (
                        <p>No hay usuarios comodín registrados.</p>
                    ) : (
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr style={{ borderBottom: '1px solid #444' }}>
                                    <th style={{ textAlign: 'left', padding: '10px' }}>Email</th>
                                    <th style={{ textAlign: 'left', padding: '10px' }}>Motivo</th>
                                    <th style={{ textAlign: 'left', padding: '10px' }}>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(wildcards).map(([encoded, data]) => (
                                    <tr key={encoded} style={{ borderBottom: '1px solid #333' }}>
                                        <td style={{ padding: '10px' }}>{data.email}</td>
                                        <td style={{ padding: '10px' }}>{data.reason}</td>
                                        <td style={{ padding: '10px' }}>
                                            <button
                                                onClick={() => handleRemoveWildcard(encoded)}
                                                style={{ background: 'red', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}
                                            >
                                                Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>

            <button
                onClick={() => window.history.back()}
                style={{ marginTop: '20px', padding: '10px 20px', background: '#666', color: 'white', border: 'none', borderRadius: '50px', cursor: 'pointer' }}
            >
                ← Volver
            </button>
        </div>
    );
};

export default WildcardManagement;
